import settings from '../../api/settings'

const state = {
  tokenList: [],
  ip: ''
};

const actions = {
  // 获取操作token列表
  async getApiTokens ({ commit, dispatch, rootState }, data) {
    const response = await settings.getApiTokens({mobileIntermediate: data});
    if (response.status === 200) {
      const { data } = response;
      if (data.tokens.length > 0) {
        commit('UPDATE_TOKENLIST', {
          tokens: data.tokens
        });
      } else {
        dispatch('setApiToken', {
          name: rootState.profile.name
        });
      }
    }
  },
  async getWhiteList ({ commit, dispatch, rootState }) {
    const response = await settings.getWhiteList();
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_WHITELIST', {
        ip: data.ip
      });
    }
  },
  async updateWhiteList ({ commit, dispatch }, payload) {
    let response = await settings.updateWhiteList(payload);
    const { data } = response;
    if (response.status === 200) {
      commit('UPDATE_WHITELIST', {
        ip: data.ip
      });
    } else {
      throw new Error(data.message);
    }
  },
  // 创建新的操作token
  async setApiToken ({ commit }, payload) {
    const response = await settings.setApiToken({ name: payload.name });
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_TOKENLIST', {
        tokens: [data.token]
      });
    }
  }
};

const mutations = {
  'UPDATE_TOKENLIST': (state, payload) => {
    state.tokenList = payload.tokens;
  },
  'UPDATE_WHITELIST': (state, payload) => {
    state.ip = payload.ip
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js